import { render, staticRenderFns } from "./organization-list-card.vue?vue&type=template&id=2af9ceda&scoped=true&"
import script from "./organization-list-card.vue?vue&type=script&lang=js&"
export * from "./organization-list-card.vue?vue&type=script&lang=js&"
import style0 from "./organization-list-card.vue?vue&type=style&index=0&id=2af9ceda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af9ceda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af9ceda')) {
      api.createRecord('2af9ceda', component.options)
    } else {
      api.reload('2af9ceda', component.options)
    }
    module.hot.accept("./organization-list-card.vue?vue&type=template&id=2af9ceda&scoped=true&", function () {
      api.rerender('2af9ceda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizations/partials/organization-list-card.vue"
export default component.exports